import { ModalAccommodationRoomContext } from 'src/contexts/ModalAccommodationRoomProvider';
import { useContext } from 'react';

const useModalAccommodationRoomContext = () => {
  return useContext(ModalAccommodationRoomContext)
}

export default useModalAccommodationRoomContext
